<template>
	<div class="relative w-full py-10 px-10">
		<div class="relative w-full flex flex-col justify-center items-start gap-4 z-20">
			<span class="text-xl md:text-2xl lg:text-3xl font-display font-semibold text-brown">
				{{ $t('welcomePage.title') }}
			</span>

			<div class="text-md md:text-lg text-brown">
				<p v-for="(t, i) in $t('welcomePage.text').split('\n')" :key="i">
					{{ t }} <br />
				</p>
			</div>
		</div>

		<div class="flex justify-center items-start flex-col mt-4 gap-0.5">
			<span class="text-md md:text-lg text-green font-display">
				{{ $t('welcomePage.explore') }}:
			</span>
			<div class="flex justify-start items-center gap-2 flex-wrap">
				<a
					v-for="link, i in discoverLinks"
					:key="i"
					:href="link.link" 
					target="_blank"
					class="text-md md:text-lg text-brown text-left underline hover:underline-offset-2 pr-2 border-green capitalize"
					:class="i === discoverLinks.length - 1 ? 'border-0' : 'border-r'"
				>
					<span>{{ $t(link.name) }}</span>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import { discoverLinks } from '../assets/config/infoConfig';

export default {
	name: 'WelcomePage',
	setup() {
		return {
			discoverLinks,
		};
	},
};
</script>
